import { styled } from '@mui/material/styles';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const SelectSCSTYLE = styled(Select)(({ theme }) => ({
  '.MuiInputBase-input': {
    paddingLeft: '8px',
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '120%',
    color: '#8F8F8F',
    paddingTop: '20px'
  },
  '.MuiSelect-icon':{
    right: '8px',
    color: '#2685CA',
    width: '1.6em',
    height: '1.6em'
  },
  '.MuiFormLabel-root.mui-focused': {
    color: '#2685CA !important'
  },
  ':before':{//MuiInputBase-root MuiInput-root
    borderBottom: '1px solid #E5E5E5'
  },
  '': {
    background: 'antiquewhite'
  },
  '.Mui-error .MuiSelect-select':{
    color: '#d32f2f'
  },
  '.MuiSelect-nativeInput':{
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '120%',
  }

}));

const SelectSC = (props) => {
  return <SelectSCSTYLE {...props} IconComponent={KeyboardArrowDownIcon}/>
}
export default SelectSC
